module.exports = __webpack_public_path__ + "static/img/scene05.a249afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene05.png
// module id = KCNQ
// module chunks = 1